import { Link } from 'react-router-dom';
import { articles, mainSiteUrl } from '@/mocks/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-950 text-foreground-100">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
            <div>
              <h4 className="font-heading text-lg font-bold text-background-50 mb-4">
                Basetao<span className="text-primary-400">Sheet</span>
              </h4>
              <p className="text-sm text-foreground-300 leading-relaxed">
                Independent educational resource helping international shoppers understand Basetao Spreadsheet systems, product research, and shipping optimization.
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wide">Quick Links</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">Home</Link>
                </li>
                <li>
                  <Link to="/basetao-spreadsheet-guide" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">Spreadsheet Guide</Link>
                </li>
                <li>
                  <Link to="/basetao-review" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">Basetao Review</Link>
                </li>
                <li>
                  <Link to="/basetao-shipping-cost" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">Shipping Cost Guide</Link>
                </li>
                <li>
                  <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors">Main Website</a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wide">More Guides</h4>
              <ul className="space-y-2.5">
                {articles.slice(3, 8).map((a) => (
                  <li key={a.slug}>
                    <Link to={`/${a.slug}`} className="text-sm text-foreground-300 hover:text-primary-400 transition-colors line-clamp-1">{a.title}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wide">Disclaimer</h4>
              <p className="text-xs text-foreground-400 leading-relaxed">
                This is an independent educational website. We are not affiliated with or endorsed by Basetao. All external links direct to kaspreadsheet.com. We do not collect payment information.
              </p>
            </div>
          </div>

          <div className="border-t border-foreground-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400">
              &copy; {currentYear} Basetao Spreadsheet Study. For educational purposes only.
            </p>
            <div className="flex items-center gap-4">
              <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-primary-400 transition-colors">Main Site</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}